import React, { useState } from "react";
// import classes from "../../assets/styles/Forms/FormInput.module.css";
import eye from "../../assets/images/signup_icons/eye.svg";
import eyeSlash from "../../assets/images/signup_icons/eye-slash.svg";
const FormInput = ({
  dateTypeInput,
  icon,
  label,
  type,
  placeholder,
  name,
  value,
  handleChange,
  error,
  iconOnClick = null,
  autofocus = false,
  disabled = false,
  socialProfiles = null,
  ...props
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const inputType = type === "password" && passwordVisible ? "text" : type;
  return (
    <>
      <div className="form-group">
        {label ? <label className="label">{label}</label> : null}
        <div
          className={
            error
              ? "input-group globalInputWithIcon errorInput"
              : "input-group globalInputWithIcon"
          }
        >
          {icon ? (
            <span className="input-group-text">
              <img
                src={icon}
                alt=""
                onClick={iconOnClick}
                style={iconOnClick ? { cursor: "pointer" } : null}
              />
            </span>
          ) : null}

          <input
            // type={type ? type : "text"}
            type={inputType ? inputType : "text"}
            className={`${error ? "form-control inputError" : "form-control"} ${
              dateTypeInput ? "customDateIcon" : ""
            }`}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            // autoComplete="off"
            autoComplete={`new-${name}`}
            autoFocus={autofocus}
            readOnly={disabled}
            {...props}
          />
          {type === "password" && (
            <button
              type="button"
              className="eyeButton p-0 border-0 px-3"
              onClick={togglePasswordVisibility}
            >
              {passwordVisible ? (
                <img src={eye} alt="Hide" />
              ) : (
                <img src={eyeSlash} alt="Show" />
              )}
            </button>
          )}
        </div>
        <p className="errorText">{error || ""}</p>
      </div>
    </>
  );
};

export default FormInput;
